import React from 'react';
import ArbitrageCalculator from './components/ArbitrageCalculator';

function App() {
  return (
    <div className="app">
      <ArbitrageCalculator />
    </div>
  );
}

export default App;